"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ChangeLanguageDialog_1 = require("../../organisms/ChangeLanguageDialog");
const device_1 = require("@completeanatomy/device");
const PreferencesServiceProvider_1 = require("../../providers/PreferencesServiceProvider");
const i18n_1 = require("@completeanatomy/i18n");
const device_2 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const LanguageSelect_1 = require("../LanguageSelect");
const options = [
    {
        name: i18n_1.Strings.settings.preferences.features.language.names.English,
        nativeName: i18n_1.Strings.settings.preferences.features.language.options.English,
        locale: 'en',
    },
    {
        name: i18n_1.Strings.settings.preferences.features.language.names.Spanish,
        nativeName: i18n_1.Strings.settings.preferences.features.language.options.Spanish,
        locale: 'es',
    },
    {
        name: i18n_1.Strings.settings.preferences.features.language.names.Chinese,
        nativeName: i18n_1.Strings.settings.preferences.features.language.options.Chinese,
        locale: 'zh',
    },
    {
        name: i18n_1.Strings.settings.preferences.features.language.names.German,
        nativeName: i18n_1.Strings.settings.preferences.features.language.options.German,
        locale: 'de',
    },
    {
        name: i18n_1.Strings.settings.preferences.features.language.names.French,
        nativeName: i18n_1.Strings.settings.preferences.features.language.options.French,
        locale: 'fr',
    },
];
const getOptionByLocale = (locale) => options.find(({ locale: l }) => locale === l) || options[0];
/**
 * Language selector component for additional settings section
 * @constructor
 */
function LanguageSelector() {
    const [opened, setOpened] = (0, react_1.useState)(false);
    const language = (0, device_2.useLanguage)();
    const [selectedOption, setSelectedOption] = (0, react_1.useState)(getOptionByLocale(language));
    const [isDialogOpened, setDialogOpened] = (0, react_1.useState)(false);
    const { isMobile } = (0, device_1.usePlatform)();
    const preferences = (0, PreferencesServiceProvider_1.usePreferencesService)();
    const descriptionRef = (0, react_1.useRef)(null);
    const [descriptionHeight, setDescriptionHeight] = (0, react_1.useState)(100);
    const onSpoilerToggle = () => {
        setOpened(prevState => !prevState);
        if (!opened) {
            const content = descriptionRef.current;
            const onTransitionEnd = () => {
                setDescriptionHeight(content.clientHeight);
                content.removeEventListener('transitionend', onTransitionEnd);
            };
            content.addEventListener('transitionend', onTransitionEnd);
        }
    };
    const onChange = (selected) => {
        if (selected.locale === selectedOption.locale) {
            return;
        }
        setSelectedOption(selected);
        setDialogOpened(true);
    };
    const onCancel = () => {
        setDialogOpened(false);
        setSelectedOption(getOptionByLocale(language));
    };
    const onConfirm = () => {
        preferences.selectApplicationLanguage(selectedOption.locale);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'LanguageSelector_Container', children: [(0, jsx_runtime_1.jsxs)(Header, { "data-e2e": 'LanguageSelector_Header', children: [(0, jsx_runtime_1.jsx)(Name, { "data-e2e": 'LanguageSelector_Name', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.name) }), isMobile && ((0, jsx_runtime_1.jsx)(InfoCircle, { onClick: onSpoilerToggle, "data-e2e": 'LanguageSelector_InfoCircle', children: (0, jsx_runtime_1.jsx)(InfoIcon, { name: ui_1.Icons.Info, selected: opened, "data-e2e": 'LanguageSelector_InfoIcon' }) }))] }), (0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'LanguageSelector_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.title) }), (0, jsx_runtime_1.jsx)(Description, { "$isOpen": opened, "$height": descriptionHeight, ref: descriptionRef, "data-e2e": 'LanguageSelector_Description', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.description) }), (0, jsx_runtime_1.jsx)(StyledLanguageSelect, { options: options, selected: selectedOption, onChange: onChange, "data-e2e": 'LanguageSelector_StyledLanguageSelect' })] }), (0, jsx_runtime_1.jsx)(ChangeLanguageDialog_1.ChangeLanguageDialog, { isOpen: isDialogOpened, onConfirm: onConfirm, onCancel: onCancel, language: selectedOption.nativeName, "data-e2e": 'LanguageSelector_ChangeLanguageDialog' })] }));
}
exports.LanguageSelector = LanguageSelector;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
const Header = styled_components_1.default.div `
  display: flex;
  align-items: center;

  margin-bottom: 12px;
`;
const Name = styled_components_1.default.span `
  color: ${({ theme }) => theme.designSystem.text};
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const InfoCircle = styled_components_1.default.button `
  flex-shrink: 0;
  box-sizing: border-box;
  width: 21px;
  height: 20px;
  margin-left: 8px;

  padding: 0;

  color: ${({ theme }) => theme.designSystem.text};

  background-color: transparent;
  border: none;
`;
const InfoIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 100%;
  height: 100%;
`;
const Title = styled_components_1.default.span `
  font-style: italic;
`;
const Description = styled_components_1.default.span `
  max-height: ${({ $isOpen, $height }) => ($isOpen ? `${$height}px` : '0px')};
  margin-top: ${({ $isOpen }) => ($isOpen ? '12px' : '0')};

  overflow: hidden;

  color: ${({ theme }) => theme.designSystem.textSecondary};

  transition: max-height 0.5s linear, margin-top 0.5s linear;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    max-height: unset;
    margin-top: 12px;
  `)}
`;
const StyledLanguageSelect = (0, styled_components_1.default)(LanguageSelect_1.LanguageSelect) `
  margin-top: 14px;
`;
